import React from "react";
interface PropsData {
  fillColor: string;
}
const AccountDetailsIcon = (props: PropsData) => {
  return (
    <div className="me-1">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5 19.2154L11.9423 15.6577L12.65 14.9499L15.5 17.7999L21.1885 12.1114L21.8962 12.8192L15.5 19.2154ZM20 10.0019H19V5.61744C19 5.46344 18.9359 5.32235 18.8078 5.19419C18.6796 5.06602 18.5385 5.00194 18.3845 5.00194H16V7.23269H8V5.00194H5.6155C5.4615 5.00194 5.32042 5.06602 5.19225 5.19419C5.06408 5.32235 5 5.46344 5 5.61744V18.3864C5 18.5404 5.06408 18.6815 5.19225 18.8097C5.32042 18.9379 5.4615 19.0019 5.6155 19.0019H11V20.0019H5.6155C5.168 20.0019 4.78683 19.8446 4.472 19.5299C4.15733 19.2151 4 18.8339 4 18.3864V5.61744C4 5.16994 4.15733 4.78877 4.472 4.47394C4.78683 4.15927 5.168 4.00194 5.6155 4.00194H10.252C10.3455 3.61094 10.5532 3.28244 10.875 3.01644C11.1968 2.75027 11.5718 2.61719 12 2.61719C12.4358 2.61719 12.8137 2.75027 13.1337 3.01644C13.4536 3.28244 13.6603 3.61094 13.7538 4.00194H18.3845C18.832 4.00194 19.2132 4.15927 19.528 4.47394C19.8427 4.78877 20 5.16994 20 5.61744V10.0019ZM12 5.23269C12.232 5.23269 12.4247 5.1561 12.578 5.00294C12.7312 4.84977 12.8078 4.6571 12.8078 4.42494C12.8078 4.19294 12.7312 4.00035 12.578 3.84719C12.4247 3.69402 12.232 3.61744 12 3.61744C11.768 3.61744 11.5753 3.69402 11.422 3.84719C11.2688 4.00035 11.1923 4.19294 11.1923 4.42494C11.1923 4.6571 11.2688 4.84977 11.422 5.00294C11.5753 5.1561 11.768 5.23269 12 5.23269Z"
          fill={props?.fillColor}
          stroke={props?.fillColor}
        />
      </svg>
    </div>
  );
};
export default AccountDetailsIcon;
